import React from 'react';
import TypeWriterEffect from 'react-typewriter-effect';
import './Typewriter.css';
import '../Pages/style.css'
const TypeWriter = () => {
 

  return (
    <div className='typewriter-text'>
      <TypeWriterEffect
        textStyle={{
          fontWeight: 700,
        }}
        startDelay={2000}
        cursorColor="#3F3D56"
        multiText={[
          "Hi, I'm Hamed Hasan",
          "Enthusiastic Data Scientist",
          "Specializing in MERN Stack",
          "Experienced Front End Developer",
          "Skilled Backend Developer",
          "Passionate about React.js",
          "Creative Graphic Designer",
          "A Professional Full Stack Developer"
        ]}
        multiTextDelay={1000}
        typeSpeed={80}
      />
    </div>
  );
};

export default TypeWriter;
